import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { UpdateStagingGateways } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<boolean, Error, UpdateStagingGateways>, 'mutationKey' | 'mutationFn'>
}

export const useEditStagingGatewaysRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<boolean, Error, UpdateStagingGateways>(
    [Entities.Configuration, 'staging-gateways'],
    async (payload: UpdateStagingGateways) => {
      const { data }: { data: unknown } = await api.v1AdminConfigurationGatewayAllocationPut(payload)
      return data as boolean
    },
    options
  )
}
